export enum Role {
  Trainee,
  Mentor,
  Admin
}



// WEBPACK FOOTER //
// ./src/lib/User.ts